import { ChatMessageDataType, ChatTypeEnum } from "./chatEnum"

export interface ChatMessage{
    id:string,
    userId:string,
    chatId: string,
    content: string,
    role: string,
    creationTimestamp: Date,
    userRating: ChatMessageRatingEnum
}

export interface ServerResMessageData{
    message: string
}

export enum ChatSpecialString{
    TERMINATION_STRING = "#*#*#*"
}

export enum ChatMessageRoles{
    USER = "user",
    SERVER = "assistant"
}

export enum ChatMessageRatingEnum{
    NATURAL = 0,
    LIKED = 1,
    DISLIKED = -1
}

export interface ChatMetadata{
    id: string,
    userId: string,
    creationTimestamp: Date,
    type:ChatTypeEnum,
    lastUpdate: Date,
    userScore: number,
    title: string,
    poiList: string[]
}

export interface EngagmentConversationQuestionData{
    id : string,
    motivationId: string,
    engagementType : number,
    energyLevel: number,
    content: string
}

export interface ConversationalUseCaseQuestionData{
    id: string,
    subjectId : string,
    roles : number[],
    content: string
}

export interface ExternalConverdationalUseCaseData{
    subjectId : string,
    subjectName : string,
    useCaseQuestions: ConversationalUseCaseQuestionData[]
}

export interface WebSocketMessageData{
    dataType: ChatMessageDataType,
    data: string
}
